export function initReveal() {
  const els = document.querySelectorAll('[data-reveal]')
  if (!els.length) return

  // Décalage en cascade : data-reveal-stagger="150" sur le parent, data-reveal sur ses enfants directs
  document.querySelectorAll('[data-reveal-stagger]').forEach(parent => {
    const step = parseInt(parent.dataset.revealStagger, 10) || 0
    parent.querySelectorAll(':scope > [data-reveal]').forEach((child, i) => {
      child.style.transitionDelay = `${i * step}ms`
    })
  })

  els.forEach(el => {
    if (el.dataset.revealDelay) el.style.transitionDelay = `${parseInt(el.dataset.revealDelay, 10)}ms`
  })

  const observer = new IntersectionObserver((entries) => {
    entries.forEach(entry => {
      if (!entry.isIntersecting) return
      entry.target.classList.add('is-visible')
      observer.unobserve(entry.target)
    })
  }, { threshold: 0.2, rootMargin: '0px 0px -10% 0px' })

  els.forEach(el => observer.observe(el))
}
